import { render, staticRenderFns } from "./CreateTerminationReason.vue?vue&type=template&id=8c0c6d0e"
import script from "./CreateTerminationReason.vue?vue&type=script&lang=js"
export * from "./CreateTerminationReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports